import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import '../css/HeaderPrivate.css';
import aiHover from '../assets/images/ai-hover.svg';
import obHover from '../assets/images/ob-hover.svg';
import mdHover from '../assets/images/md-hover.svg';
import siHover from '../assets/images/si-hover.svg';
import ivHover from '../assets/images/iv-hover.svg';
import mlHover from '../assets/images/ml-hover.svg';
import sub_hover from '../assets/images/sub_hover.svg';
import Distributor_hover from '../assets/images/Distributor_hover.svg';
import user from '../assets/images/user.svg';
import dropdown from '../assets/images/dropdown.svg';
import search from '../assets/images/search.svg';
import searchActive from '../assets/images/searchActive.svg';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import LogoutButton from './LogoutButton';
import { Button, Menu, MenuItem } from '@mui/material';
import { is_allowed } from '../utilitis';



//header section of private pages of cloud studio
class HeaderPrivate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listOpen: false,
            anchorEl: null,
            navTabClsSI: ['nav-tab-content'],
            navTabClsML: ['nav-tab-content'],
            navTabClsMD: ['nav-tab-content'],
            navTabClsAI: ['nav-tab-content'],
            navTabClsOB: ['nav-tab-content'],
            navTabClsVersion: ['nav-tab-content'],
            navTabClsRole: ['nav-tab-content'],
            navTabClsOta: ['nav-tab-content'],
            navTabClsUser: ['nav-tab-content'],
            navTabClsSupport: ['nav-tab-content'],
            navTabClsDistributor: ['nav-tab-content'],
            navTabClsSubscriptions: ['nav-tab-content'],
            navTabClsMarketSpace: ['nav-tab-content'],
            navTabLogo: '',
            dropdownOpen: false,
            permissionData: [],
            logoutMenu: false
        }
        this.toggle = this.toggle.bind(this);
    }

    ///////
    handleDropdownClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleDropdownClose = (tab) => {
        this.setState({ anchorEl: null });
        if (tab) {
            this.onClick(tab);
        }
    };


    ////////

    logOut = (e) => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }




    componentWillMount() {
        this.fetchPermissions()
        // this.fetchNotification()
        // if (window.location.pathname.includes('/masterdevice/alldevice')) {
        if (window.location.pathname.includes('/masterdevice/alldevice')) {

            this.setState({
                navTabClsMD: [
                    ...this.state.navTabClsMD,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsOta: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
            // } else if (window.location.pathname.includes('/systemintegrator/system')) {
        } else if (window.location.pathname.includes('/systemintegrator/system')) {
            this.setState({
                navTabClsSI: [
                    ...this.state.navTabClsSI,
                    'font-weight-bold'
                ],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsOta: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
            // } else if (window.location.pathname.includes('/ai/')) {
        } else if (window.location.pathname.includes('/ai/')) {
            this.setState({
                navTabClsAI: [
                    ...this.state.navTabClsAI,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
            // } else if (window.location.pathname.includes('/okasboxes/')) {
        } else if (window.location.pathname.includes('/okasboxes/')) {

            this.setState({
                navTabClsOB: [
                    ...this.state.navTabClsOB,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
            // } else if (window.location.pathname.includes('/memberlicense/')) {
        } else if (window.location.pathname.includes('/memberlicense/')) {
            this.setState({
                navTabClsML: [
                    ...this.state.navTabClsML,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
            // } else if (window.location.pathname.includes('/version/')) {

        } else if (window.location.pathname.includes('/version/')) {
            this.setState({
                navTabClsVersion: [
                    ...this.state.navTabClsVersion,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],





            })
            // } else if (window.location.pathname.includes('/distributor')) { 
        } else if (window.location.pathname.includes('/distributor')) {
            this.setState({
                navTabClsDistributor: [
                    ...this.state.navTabClsDistributor,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],


            })
            // }  else if (window.location.pathname.includes('/subscriptions')) {   
        } else if (window.location.pathname.includes('/subscriptions')) {

            this.setState({
                navTabClsSubscriptions: [
                    ...this.state.navTabClsSubscriptions,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsMarketSpace: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
        }
        // else if (window.location.pathname.includes('/marketspace')) {  
        else if (window.location.pathname.includes('/marketspace')) {
            this.setState({
                navTabClsMarketSpace: [
                    ...this.state.navTabClsMarketSpace,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsSupport: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],


            })
            // } else if (window.location.pathname.includes('/support')) {   
        } else if (window.location.pathname.includes('/support')) {
            this.setState({
                navTabClsSupport: [
                    ...this.state.navTabClsSupport,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
        }

        else if (window.location.pathname.includes('/role')) {
            this.setState({
                navTabClsRole: [
                    ...this.state.navTabClsRole,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsUser: ['nav-tab-content'],



            })
        }
        else if (window.location.pathname.includes('/user')) {
            this.setState({
                navTabClsUser: [
                    ...this.state.navTabClsUser,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],
                navTabClsOta: ['nav-tab-content'],




            })
        }
        else if (window.location.pathname.includes('/ota')) {
            this.setState({
                navTabClsUser: [
                    ...this.state.navTabClsUser,
                    'font-weight-bold'
                ],
                navTabClsSI: ['nav-tab-content'],
                navTabClsAI: ['nav-tab-content'],
                navTabClsMD: ['nav-tab-content'],
                navTabClsOB: ['nav-tab-content'],
                navTabClsML: ['nav-tab-content'],
                navTabClsSubscriptions: ['nav-tab-content'],
                navTabClsVersion: ['nav-tab-content'],
                navTabClsRole: ['nav-tab-content'],




            })
        }
        
    }
    

    navTabShowHandler = () => {
        if (window.location.pathname.includes('/masterdevice/alldevice')) {
            return <img src={mdHover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/systemintegrator/system')) {
            return <img src={siHover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/ai/')) {
            return <img src={aiHover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/okasboxes/')) {
            return <img src={obHover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/version')) {
            return <img src={ivHover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/memberlicense')) {
            return <img src={mlHover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/distributor')) {
            return <img src={Distributor_hover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/subscriptions')) {
            return <img src={sub_hover} style={{ width: '30px', height: '30px' }} />
        } else if (window.location.pathname.includes('/marketspace')) {
            return <img src={sub_hover} style={{ width: '30px', height: '30px' }} />
        } else {
            return null;
        }
    }

    onClick = (value) => {
        if (value === 'si') {
            window.location.href = '/systemintegrator/system'
        } else if (value === 'ml') {
            window.location.href = '/memberlicense/dashboard'
        } else if (value === 'distributor') {
            window.location.href = '/distributor';  // Added actual path of distributor 
        }
        else if (value === 'md') {
            window.location.href = '/masterdevice/alldevice'
        } else if (value === 'ai') {
            window.location.href = '/ai/dashboard'
        } else if (value === 'ob') {
            window.location.href = '/okasboxes/dashboard'
        } else if (value === 'version') {
            window.location.href = '/version/internal'
        } else if (value === 'support') {
            window.location.href = '/support'
        } else if (value === 'subscriptions') { // Added actual path of subscriptions
            window.location.href = '/subscriptions'

        } else if (value === 'marketspace') { // Added actual path of marketspace
            window.location.href = '/marketspace'

        } else if (value === 'role') { // Added actual path of role
            window.location.href = '/role'

        } else if (value === 'user') { // Added actual path of role
            window.location.href = '/user'

        }
        else if (value === 'ota') { // Added actual path of role
            window.location.href = '/ota'

        }
       
    }


    fetchNotification = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/getnotification/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({forceRefresh: true})
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                //console.log(data);
                if (data.detail === 'Invalid token.') {
                    localStorage.clear();
                    window.location.href = '/'
                } else {
                    this.setState({
                        notificationData: data
                    }, () => this.forceUpdate())
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    fetchPermissions = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/userPermissionDetails/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({forceRefresh: true})
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            // .then(data => {
            //     if (data.detail === 'Invalid token.') {
            //         localStorage.clear();
            //         window.location.href = '/'
            //     } else {
            //        console.log(data.userData.name);

            //         this.props.setPermssions(data.userData.role.permissions);

            //         // this.setState({
            //         //     permissionData: data
            //         // })
            //     }
            // })
            .then(data => {
                if (data.detail === 'Invalid token.') {
                    localStorage.clear();
                    window.location.href = '/';
                } else {
                    // ✅ Log si_name from API
                    //console.log("Fetched name:", data.si_name);

                    // ✅ Ensure userData and role exist before accessing permissions
                    if (data.userData && data.userData.role) {
                        this.props.setPermssions(data.userData.role.permissions);
                    }
                    // else {
                    //     console.warn("Missing userData or role in API response");
                    // }

                    // ✅ Update state and confirm it updated
                    this.setState({ fetchedUserName: data.si_name || "" }, () => {
                        //console.log("State updated with name:", this.state.fetchedUserName);
                    });
                }
            })


            .catch((err) => {
                console.log(err)
            })

    }

    markAsRead = (id) => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/readnotification/', {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                id
            })
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({forceRefresh: true})
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                if (data === 'success') {
                    // this.fetchNotification()
                }
            })
            .catch((err) => {
                console.log(err)

            })
    }
    navBarNew = () => {
        return (
            <ul style={{ zIndex: '1' }}>
                <li style={{}}>
                    <Link to="/dashboard">
                        <img src={logo} alt="logo" style={{ width: '188px', height: '30px', marginRight: '40px' }} />
                    </Link>
                </li>

                <li>
                </li>
                {localStorage.getItem("user_type") === "1" && (
                    <>
                        <li className={this.state.navTabClsOB.join(' ')} onClick={this.onClick.bind(this, 'ob')}>
                            <a style={{ fontSize: '13px' }}>OKAS Inventory</a>
                        </li>
                        <li className={this.state.navTabClsDistributor.join(' ')} onClick={this.onClick.bind(this, 'distributor')}>
                            <a style={{ fontSize: '13px' }}>Distributor</a>
                        </li>
                        <li className={this.state.navTabClsSI.join(' ')} onClick={this.onClick.bind(this, 'si')}>
                            <a style={{ fontSize: '13px' }}>SI</a>
                        </li>
                        <li className={this.state.navTabClsSubscriptions.join(' ')} onClick={this.onClick.bind(this, 'subscriptions')}>
                            <a style={{ fontSize: '13px' }}>Subscriptions</a>
                        </li>
                        <li className={this.state.navTabClsML.join(' ')} onClick={this.onClick.bind(this, 'ml')}>
                            <a style={{ fontSize: '13px' }}>Member License</a>
                        </li>
                        <li className={this.state.navTabClsMD.join(' ')} onClick={this.onClick.bind(this, 'md')}>
                            <a style={{ fontSize: '13px' }}>Master Devices</a>
                        </li>

                        <li style={{ marginTop: '6px' }}>
                            <Button
                                onClick={this.handleDropdownClick}
                                sx={{
                                    fontSize: '13px',
                                    textTransform: 'none',
                                    color: '#212529',
                                    outline: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    },
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                        boxShadow: 'none',
                                    },
                                    '&:active': {
                                        border: 'none',
                                        boxShadow: 'none',
                                        backgroundColor: 'transparent',
                                    },
                                }}
                                disableRipple
                                endIcon={<img src={dropdown} alt="dropdown icon" style={{ width: 10, height: 10 }} />}
                            >
                                More Options
                            </Button>

                            <Menu
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={() => this.handleDropdownClose(null)}
                            >
                                <MenuItem onClick={() => this.handleDropdownClose('marketspace')}>Market Place</MenuItem>
                                <MenuItem onClick={() => this.handleDropdownClose('support')}>Support</MenuItem>
                                <MenuItem onClick={() => this.handleDropdownClose('version')}>Version</MenuItem>
                                <MenuItem onClick={() => this.handleDropdownClose('role')}>Role</MenuItem>
                                <MenuItem onClick={() => this.handleDropdownClose('user')}>User</MenuItem>
                                <MenuItem onClick={() => this.handleDropdownClose('ota')}>OTA</MenuItem>
                                
                            </Menu>
                        </li>
                    </>
                )}

                {localStorage.getItem("user_type") === "2" && (

                    <>
                        {/* {is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "okas inventory") && */}
                        {["view", "add", "edit", "delete", "assign okas inventory"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "okas inventory", action)) && (
                            <li className={this.state.navTabClsOB.join(' ')} onClick={this.onClick.bind(this, 'ob')}>
                                <a style={{ fontSize: '13px' }}>OKAS Inventory</a>
                            </li>)}

                        {["view", "add", "edit", "delete"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "distributor", action)) && (

                            <li className={this.state.navTabClsDistributor.join(' ')} onClick={this.onClick.bind(this, 'distributor')}>
                                <a style={{ fontSize: '13px' }}>Distributor</a>
                            </li>)}
                        {["view", "edit"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "si", action)) && (

                            <li className={this.state.navTabClsSI.join(' ')} onClick={this.onClick.bind(this, 'si')}>
                                <a style={{ fontSize: '13px' }}>SI</a>
                            </li>)}
                        {["view"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "subscription", action)) && (

                            <li className={this.state.navTabClsSubscriptions.join(' ')} onClick={this.onClick.bind(this, 'subscriptions')}>
                                <a style={{ fontSize: '13px' }}>Subscriptions</a>
                            </li>)}
                        {["view", "add", "edit", "delete", "assign license"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "member license", action)) && (

                            <li className={this.state.navTabClsML.join(' ')} onClick={this.onClick.bind(this, 'ml')}>
                                <a style={{ fontSize: '13px' }}>Member License</a>
                            </li>)}
                        {["view", "add"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "master device", action)) && (

                            <li className={this.state.navTabClsMD.join(' ')} onClick={this.onClick.bind(this, 'md')}>
                                <a style={{ fontSize: '13px' }}>Master Devices</a>
                            </li>)}

                        <li style={{ marginTop: '6px' }}>
                            <Button
                                onClick={this.handleDropdownClick}
                                sx={{
                                    fontSize: '13px',
                                    textTransform: 'none',
                                    color: '#212529',
                                    outline: 'none',
                                    border: 'none',
                                    boxShadow: 'none',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        boxShadow: 'none',
                                    },
                                    '&:focus': {
                                        outline: 'none',
                                        border: 'none',
                                        boxShadow: 'none',
                                    },
                                    '&:active': {
                                        border: 'none',
                                        boxShadow: 'none',
                                        backgroundColor: 'transparent',
                                    },
                                }}
                                disableRipple
                                endIcon={<img src={dropdown} alt="dropdown icon" style={{ width: 10, height: 10 }} />}
                            >
                                More Options
                            </Button>

                            <Menu
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={() => this.handleDropdownClose(null)}
                            >
                                {["add", "delete", "edit", "view"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", action)) && (
                                    <MenuItem onClick={() => this.handleDropdownClose('marketspace')}>Market Place</MenuItem>)}
                                {["reply", "view", "request remote access", "access design studio", "share ticket"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "support", action)) && (
                                    <MenuItem onClick={() => this.handleDropdownClose('support')}>Support</MenuItem>)}
                                {["view", "add", "public version"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "version", action)) && (
                                    <MenuItem onClick={() => this.handleDropdownClose('version')}>Version</MenuItem>)}
                                {["add", "delete", "edit", "view"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "role", action)) && (
                                    <MenuItem onClick={() => this.handleDropdownClose('role')}>Role</MenuItem>)}
                                {["add", "delete", "edit", "view"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "user", action)) && (
                                    <MenuItem onClick={() => this.handleDropdownClose('user')}>User</MenuItem>)}
                                {["add", "delete", "edit", "view"].some(action => is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "ota", action)) && (
                                    <MenuItem onClick={() => this.handleDropdownClose('ota')}>OTA</MenuItem>)}    
                            </Menu>
                        </li>
                    </>
                )}

                <li style={{ float: 'right', position: 'relative', cursor: 'pointer' }} >
                    <LogoutButton />
                </li>
                {/* <li style={{ float: 'right', }} >
                    <img src={user} style={{ width: '30px', height: '30px', margin: '15px 10px 15px 10px' }} data-toggle="tooltip"  title={this.state.fetchedUserName} data-placement="left" />
                </li> */}
                <li style={{ float: 'right' }}>
                    <img
                        src={user}
                        alt="User"
                        style={{
                            width: '30px',
                            height: '30px',
                            margin: '15px 10px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            cursor: 'pointer',
                        }}
                        title={this.state.fetchedUserName?.toUpperCase()}
                        data-toggle="tooltip"
                        data-placement="left"
                    />
                </li>

                <li style={{ float: 'right', }}>
                    <div style={{ backgroundColor: '#EBEBF2', width: '2px', height: '30px', margin: '15px 10px 15px 10px' }}></div>
                </li>
                <li style={{ float: 'right', }} className="pointer"
                    onClick={(e) => {
                        this.props.searchBarActivate(!this.props.redux.auth.searchBarShow)
                    }}>
                    {this.props.redux.auth.searchBarShow ? <img src={searchActive} style={{ width: '20px', height: '20px', margin: '20px 5px 20px 10px' }} /> : <img src={search} style={{ width: '20px', height: '20px', margin: '20px 5px 20px 10px' }} />}
                    {/* <img src={search} style={{ width: '20px', height: '20px', margin: '20px 5px 20px 10px'}} /> */}
                </li>
            </ul>
        )
    }
    render() {
        return (
            <React.Fragment>
                <div className='navBar'>
                    {this.navBarNew()}
                </div>
            </React.Fragment>

        )
    }
}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        setPermssions: (data) => dispatch({ type: ActionTypes.PERMISSIONS, data: data })

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(HeaderPrivate);